import { Link } from "react-router-dom";

// images import
import blog1 from "../assets/images/blog-1.jpg";
import blog2 from "../assets/images/blog-2.jpg";
import blog3 from "../assets/images/blog-3.jpg";
import blog4 from "../assets/images/blog-4.jpg";
import blog5 from "../assets/images/blog-5.jpg";
import blog6 from "../assets/images/blog-6.jpg";
import blog7 from "../assets/images/blog-7.jpg";
import blog8 from "../assets/images/blog-8.jpg";
import blog9 from "../assets/images/blog-9.jpg";
import blog10 from "../assets/images/blog-10.jpg";
import blog11 from "../assets/images/blog-11.jpg";
import blog12 from "../assets/images/blog-12.jpg";

function BlogSection() {

  const blogs = [
    {
      img: blog1,
      category: "AI",
      date: "Jan 10, 2026",
      author: "Admin",
      title: "Introduction to Data Science",
      desc: "Learn the basics of data science and how it powers modern businesses.",
      link: "/blog/introduction-data-science"
    },
    {
      img: blog2,
      category: "ML",
      date: "Jan 12, 2026",
      author: "Rahul",
      title: "Machine Learning Explained",
      desc: "Understand how machines learn from data and improve predictions.",
      link: "/blog/machine-learning"
    },
    {
      img: blog3,
      category: "Deep Learning",
      date: "Jan 15, 2026",
      author: "Priya",
      title: "Deep Learning Fundamentals",
      desc: "Dive into neural networks and how deep learning works.",
      link: "/blog/deep-learning"
    },
    {
      img: blog4,
      category: "Visualization",
      date: "Jan 22, 2026",
      author: "Ankit",
      title: "Data Visualization Techniques",
      desc: "Turn complex data into simple visual insights using charts.",
      link: "/blog/data-visualization"
    },
    {
      img: blog5,
      category: "AI",
      date: "Jan 28, 2026",
      author: "Komal",
      title: "Python for Data Analysis",
      desc: "Use Python libraries like Pandas and NumPy for data analysis.",
      link: "/blog/python-data-analysis"
    },
    {
      img: blog6,
      category: "ML",
      date: "Feb 02, 2026",
      author: "Megha",
      title: "Big Data Technologies",
      desc: "Explore tools like Hadoop and Spark for handling big data.",
      link: "/blog/big-data"
    },
    {
      img: blog7,
      category: "Deep Learning",
      date: "Feb 08, 2026",
      author: "Disha",
      title: "AI in Business",
      desc: "Discover how AI is transforming industries worldwide.",
      link: "/blog/ai-business"
    },
    {
      img: blog8,
      category: "ML",
      date: "Feb 10, 2026",
      author: "Dinesh",
      title: "Data Cleaning Best Practices",
      desc: "Learn how to clean and prepare data for accurate analysis.",
      link: "/blog/data-cleaning"
    },
    {
      img: blog9,
      category: "AI",
      date: "Feb 18, 2026",
      author: "Gopal",
      title: "Predictive Analytics",
      desc: "Use historical data to predict future trends and outcomes.",
      link: "/blog/predictive-analytics"
    },
    {
      img: blog10,
      category: "Deep Learning",
      date: "Feb 20, 2026",
      author: "Ganesh",
      title: "Natural Language Processing",
      desc: "Understand how machines interpret human language.",
      link: "/blog/nlp"
    },
    {
      img: blog11,
      category: "Visualization",
      date: "Mar 11, 2026",
      author: "Divya",
      title: "Data Science Career Guide",
      desc: "Step-by-step roadmap to becoming a data scientist.",
      link: "/blog/career-guide"
    },
    {
      img: blog12,
      category: "AI",
      date: "Mar 18, 2026",
      author: "Rajesh",
      title: "Ethics in AI",
      desc: "Learn about ethical challenges and responsible AI development.",
      link: "/blog/ethics-ai"
    }
  ];

  return (
    <section className="blog-section">
      <div className="container">

        {/* Header */}
        <div className="section-header">
          <h2>Latest Insights in Data Science</h2>
          <p>Explore trends, tutorials, and expert insights in data & AI.</p>
        </div>

        {/* Grid */}
        <div className="blog-grid">
          {blogs.map((blog, index) => (
            <div className="blog-card" key={index}>

              <div className="blog-image">
                <img src={blog.img} alt="blog" />
                <span className="category">{blog.category}</span>
              </div>

              <div className="blog-content">
                <div className="meta">
                  <span>📅 {blog.date}</span>
                  <span>👤 {blog.author}</span>
                </div>

                <h3>
                  <Link to={blog.link}>{blog.title}</Link>
                </h3>

                <p>{blog.desc}</p>

                <Link to={blog.link} className="read-more">
                  Read More →
                </Link>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default BlogSection;